import api from './request'

const searchAfterSales = (waybillId, teamId, userId, onlySearch, newVersion) => {
    return api.getPromise('/afterSale/searchAfterSales', {waybillId, teamId, userId, onlySearch, newVersion})
}

const processAfterSale = (comment, teamId, printerCode, info, userId) => {
    return api.postPromise('/afterSale/processAfterSale', {comment, teamId, printerCode, userId}, info)
}

const reprintByWaybillId = (waybillId, userId, deviceId, originWaybillId, realSku, teamId) => {
    return api.getPromise('/afterSale/reprintByWaybillId', {
        waybillId,
        userId,
        deviceId,
        originWaybillId,
        realSku,
        teamId
    })
}

const recreateQrCode = (qrText, teamId, userId, printerCode) => {
    return api.getPromise('/afterSale/recreateQrCode', {qrText, teamId, userId, printerCode})
}

const unusualRecord = (waybillId, unusual, description, userId, teamId) => {
    return api.getPromise('/afterSale/unusualRecord', {
        waybillId, unusual, description,
        userId, teamId
    })
}

const findAllPrinters = (source, warehouseId) => {
    return api.getPromise('printer/findAllPrinters', {source, warehouseId})
}

const reprintByAfterSale = (afterSaleId, deviceId, realSku, defective) => {
    return api.getPromise('afterSale/reprintByAfterSale', {afterSaleId, deviceId, realSku, defective})
}

const addInterceptRemark = (waybillId, remark, teamId) => {
    return api.getPromise('afterSale/addInterceptRemark', {waybillId, remark, teamId})
}

const searchWaybillInterceptOrder = (waybillId, teamId) => {
    return api.getPromise('afterSale/searchWaybillInterceptOrder', {waybillId, teamId})
}

const scanPackageByCourier = (waybill, courier) => {
    return api.getPromise('afterSale/scanPackageByCourier', {waybill, courier})
}

const expressDeliveryList = (query, page, size, sessionKey) => {
    sessionKey = api.sessionKeyExist() ? null : sessionKey
    return api.postPromise('afterSale/expressDeliveryList', {page, size, sessionKey}, query, null, true)
}

const syncAfterSaleOrder = (orderId) => {
    return api.getPromise('tiktok/syncAfterSaleOrder', {orderId})
}

const findSourceByInterceptWaybill = (waybillId) => {
    return api.getPromise('afterSale/findSourceByInterceptWaybill', {
        waybillId
    })
}

const findTeamByAfterSaleWaybillId = (waybillId) => {
    return api.getPromise('afterSale/findTeamByAfterSaleWaybillId', { waybillId })
}

export default {
    searchAfterSales,
    processAfterSale,
    reprintByWaybillId,
    recreateQrCode,
    unusualRecord,
    findAllPrinters,
    reprintByAfterSale,
    addInterceptRemark,
    searchWaybillInterceptOrder,
    scanPackageByCourier,
    expressDeliveryList,
    syncAfterSaleOrder,
    findSourceByInterceptWaybill,
    findTeamByAfterSaleWaybillId
}



// WEBPACK FOOTER //
// ./src/request/afterSaleApi.js